import React from 'react'

import { SectionContainer, SectionTitle, ContactForm } from '../../_common'

const Contact = () => {
  return (
    <SectionContainer sectionID="contact">
      <SectionTitle centered title="Contáctanos" />
      <ContactForm />
    </SectionContainer>
  )
}

export default Contact
